import classNames from "classnames";
import Mousetrap from "mousetrap";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import { Row, Col, Nav, NavItem, Table, FormControl, Glyphicon, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Creatable } from "react-select";
import "react-select/dist/react-select.css";
import _ from "lodash";
import $ from "jquery";

import Pagination from "../deprecated_dependencies/rbs_pagination/Pagination";

import AccountStore from "../stores/AccountStore";
import CategoryStore from "../stores/CategoryStore";
import CurrencyStore from "../stores/CurrencyStore";
import TagStore from "../stores/TagStore";

import AccountActions from "../actions/AccountActions";
import CategoryActions from "../actions/CategoryActions";
import TagActions from "../actions/TagActions";

import AccountingHelper from "../utils/AccountingHelper";
import DateHelper from "../utils/DateHelper";
import DatePicker from "../utils/DatePicker";

import CategorySelect from "./CategorySelect";
import DescriptionComplete from "./DescriptionComplete";
import InputAmount from "./InputAmount";
import SplitTransactionEdit from "./SplitTransactionEdit";
import TransactionMobileEdit from "./TransactionMobileEdit";

function distance(rect, p)
{
	const dx = Math.max(rect.left - p.x, 0, p.x - rect.right);
	const dy = Math.max(rect.top - p.y, 0, p.y - rect.bottom);
	return Math.sqrt(dx*dx + dy*dy);
}

export default class Transactions extends React.Component
{
	constructor(props)
	{
		super(props);

		const state = Transactions.getStoreState();

		// This handles navigating back to the page.
		// There may be a selectedAccount in the store, but a different (or none) id in the query
		// in which case, the account will be selected and re-render the page
		state.selectedAccount = null;
		state.transferAccountId = null;
		state.showEditModal = false;
		state.accountCollapsed = true;
		state.lastUsedDate = null;
		state.showHoverAccount = false;

		state.sort = [];
		state.width = window.innerWidth;
		state.height = window.innerHeight - 60;

		state.multiValue = [];
		state.options = [];

		this.state = state;
		this._onChange = this._onChange.bind(this);
		this.handleCancelTransfer = this.handleCancelTransfer.bind(this);
		this.handleCreateTransfer = this.handleCreateTransfer.bind(this);
		this.handleEditModalClose = this.handleEditModalClose.bind(this);
		this.handleFieldBlur = this.handleFieldBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleLineItemAmountChange = this.handleLineItemAmountChange.bind(this);
		this.handleLineItemCategoryChange = this.handleLineItemCategoryChange.bind(this);
		this.handleLineItemDateChange = this.handleLineItemDateChange.bind(this);
		this.handleLineItemDelete = this.handleLineItemDelete.bind(this);
		this.handleLineItemDescriptionChange = this.handleLineItemDescriptionChange.bind(this);
		this.handleLineItemDescriptionSelect = this.handleLineItemDescriptionSelect.bind(this);
		this.handleLineItemIsCreditRefundChange = this.handleLineItemIsCreditRefundChange.bind(this);
		this.handleLineItemNew = this.handleLineItemNew.bind(this);
		this.handleLineItemNewMobile = this.handleLineItemNewMobile.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleSearchStringChange = this.handleSearchStringChange.bind(this);
		this.handleSelectPage = this.handleSelectPage.bind(this);
		this.handleTransferAccountSelected = this.handleTransferAccountSelected.bind(this);
		this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
		this.handleTagsChange = this.handleTagsChange.bind(this);
		this.handleNewTagCreate = this.handleNewTagCreate.bind(this);
		this.handleSaveTags = this.handleSaveTags.bind(this);
		this.handleCancelTags = this.handleCancelTags.bind(this);
		this.navigateToAccount = this.navigateToAccount.bind(this);
		this.handleExchangeRateChange = this.handleExchangeRateChange.bind(this);
		this.handleTargetAmountChange = this.handleTargetAmountChange.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
	}

	static getStoreState()
	{
		const selectedAccount = AccountStore.getSelected();
		let numberDecimals = 2;
		if (selectedAccount && selectedAccount.currencyId)
		{
			numberDecimals = AccountingHelper.getNumberDecimals(selectedAccount.currencyId);
		}

		return {
			accounts: AccountStore.getAccounts(),
			categories: CategoryStore.getCategories(),
			selectedAccount: selectedAccount,
			lineItems: AccountStore.getLineItems(),
			paging: AccountStore.getPaging(),
			tags: TagStore.getTags(),
			numberDecimals: numberDecimals
			// TODO: BA-114 get all transactions to be able to show for multiple accounts
		};
	}

	selectLineItem(lineItemId, event)
	{
		if (event && _.isFunction(event.persist))
		{
			event.persist();
		}
		const currentItem = this.state.selectedLineItem;
		let selectedLineItem = this.state.lineItems.find(lineItem => lineItem.id === lineItemId) || null;
		if (selectedLineItem)
		{
			selectedLineItem = JSON.parse(JSON.stringify(selectedLineItem));
		}

		selectedLineItem.isExpense = this.isLineItemExpense(selectedLineItem.categoryId);
		if ((!selectedLineItem.isExpense && selectedLineItem.amount < 0) || (selectedLineItem.isExpense && selectedLineItem.amount > 0))
		{
			selectedLineItem.isCreditRefund = true;
		}

		if (currentItem && currentItem.id !== lineItemId)
		{
			this.handleLineItemSave().then(() =>
			{
				this._internalSelectItem(selectedLineItem, event);
			});
		}
		else
		{
			this._internalSelectItem(selectedLineItem, event);
		}
	}

	isLineItemExpense(categoryId)
	{
		const inputCategory = this.state.categories.find(cat => cat.id === categoryId);
		if (inputCategory && inputCategory.type === Enums.categoryType.expense)
		{
			return true;
		}
		return false;
	}

	_internalSelectItem(selectedLineItem, event)
	{
		let target = event && event.target;
		let mouse = { x: 0, y: 0 };
		if (target)
		{
			mouse = { x: event.clientX + document.body.scrollLeft, y: event.clientY + document.body.scrollTop };
		}

		let tags = [];
		if (selectedLineItem.tags && selectedLineItem.tags.length)
		{
			tags = selectedLineItem.tags.map(tag => { return { text: tag }; });
		}
		this.setState({
			selectedLineItem,
			optionsExpanded: false,
			showExchangeRate: false,
			transferAccountId: selectedLineItem.transferAccountId || null,
			multiValue: tags
		}, () => {
			// If we mouse clicked, select the closest element, or the description if we can't determine
			if (event && event.type === "click")
			{
				if (this.activeRow)
				{
					const children = $(this.activeRow).find("input");
					let hoveredChild = null;
					for (let index = 0; index < children.length; index++)
					{
						let boundingRect = children.get(index).getBoundingClientRect();
						let hovered = mouse.x >= boundingRect.left && mouse.x <= boundingRect.right
							&& mouse.y >= boundingRect.top && mouse.y <= boundingRect.bottom;
						if (hovered)
						{
							hoveredChild = children.eq(index);
							break;
						}
					}
					if (hoveredChild && hoveredChild.length)
					{
						hoveredChild.focus();
					}
					else
					{
						let minimum = 9000;
						let minimumChild = null;
						for (let index = 0; index < children.length; index++)
						{
							let boundingRect = children.get(index).getBoundingClientRect();
							let distanceToRectangle = distance(boundingRect, mouse);
							if (distanceToRectangle < minimum)
							{
								minimumChild = children.eq(index);
								minimum = distanceToRectangle;
							}
						}
						if (minimumChild && minimumChild.length)
						{
							minimumChild.focus();
						}
						else
						{
							// No matching bounding box found, defaulting to description
							$("tr.active .descriptionComplete input").focus();
						}
					}
				}
				else
				{
					console.debug("No active row.");
				}
			}
			else if (event && event.type === "keydown")
			{
				if (event.shiftKey)
				{
					// Going up, focus on last column
					$("tr.active button.btn-danger").focus();
				}
				else
				{
					// Going down, focus on first item
					$("tr.active .date input").focus();
				}
			}
		});
	}

	handleScroll()
	{
		const $accountsContainer = $("#accountsContainer");
		let showHoverAccount = false;
		if ($accountsContainer[0].getBoundingClientRect().bottom < 0)
		{
			showHoverAccount = true;
		}
		if (this.state.showHoverAccount !== showHoverAccount)
		{
			this.setState({ showHoverAccount });
		}
	}

	// Gets debounced, see componentDidMount
	async handleSearch(search)
	{
		const selectedAccount = this.state.selectedAccount;

		if (!selectedAccount || !selectedAccount.id)
		{
			console.error("Attempting to search without a valid account.");
			return;
		}

		await AccountActions.getLineItems(selectedAccount.id, this.state.selectedPage, this.state.sort, search);
	}

	async handleSearchStringChange(event)
	{
		const search = event.target.value;
		this.setState({ search });
		await this.handleSearch(search);
	}

	handleLineItemCategoryChange(category)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.categoryId = category ? category.id : null;

		selectedLineItem.isExpense = this.isLineItemExpense(category.id);
		selectedLineItem.isCreditRefund = false;

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleLineItemDateChange(value)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.date = value;

		this.setState({
			lastUsedDate: value,
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleLineItemDescriptionSelect(lineItemPrefill)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.description = lineItemPrefill.description;
		if (!selectedLineItem.categoryId)
		{
			selectedLineItem.categoryId = lineItemPrefill.categoryId;
			selectedLineItem.isExpense = this.isLineItemExpense(lineItemPrefill.categoryId);
			selectedLineItem.isCreditRefund = false;
			if (selectedLineItem.isExpense && lineItemPrefill.amount > 0)
			{
				selectedLineItem.isCreditRefund = true;
			}
			else if (!selectedLineItem.isExpense && lineItemPrefill.amount < 0)
			{
				selectedLineItem.isCreditRefund = true;
			}
		}
		if (!selectedLineItem.amount)
		{
			selectedLineItem.amount = Math.abs(lineItemPrefill.amount);
		}

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleLineItemDescriptionChange(value)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.description = value;

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleLineItemAmountChange(value)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.amount = value;

		// TODO: handle case where we make changes here and have a transfer transaction to alternate currency

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleLineItemIsCreditRefundChange(event)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.isCreditRefund = event.target.checked;

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleExchangeRateChange(value)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.exchangeRate = value;
		if (value)
		{
			selectedLineItem.targetAmount = AccountingHelper.toFixed(AccountingHelper.convertAmount(selectedLineItem.amount, /*exchangeRate*/ value), 2);
		}
		else
		{
			selectedLineItem.targetAmount = null;
		}

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleTargetAmountChange(value)
	{
		const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
		selectedLineItem.targetAmount = value;
		if (value)
		{
			selectedLineItem.exchangeRate = AccountingHelper.toFixed(Math.abs(value / selectedLineItem.amount), 4);
		}
		else
		{
			selectedLineItem.exchangeRate = null;
		}

		if (selectedLineItem.amount < 0)
		{
			selectedLineItem.targetAmount = 0 - selectedLineItem.targetAmount;
		}

		this.setState({
			selectedLineItem,
			unsavedChanges: true
		});
	}

	handleCreateTransfer()
	{
		this.handleLineItemSave(/*includeTransferId*/ true);
	}

	handleCancelTransfer()
	{
		this.setState({ transferAccountId: null });
		// this.setState({
		// 	//optionsExpanded: false,
		// 	transferAccountId: null
		// }, () => $("tr.active .descriptionComplete input").focus());
	}

	handleTransferAccountSelected(event)
	{
		let showExchangeRate = false;
		const transferAccountId = +event.target.value;
		let stateUpdate = { transferAccountId: transferAccountId };
		if (transferAccountId)
		{
			let source = null;
			let target = null;

			if (this.state.selectedAccount.currencyId)
			{
				
				source = this.state.selectedAccount.currencyId;
			}
			const selectedTransferAccount = this.state.accounts.find(a => a.id === transferAccountId);
			if (selectedTransferAccount && !!selectedTransferAccount.currencyId)
			{
				target = selectedTransferAccount.currencyId;
			}

			if ((source || target) && source != target)
			{
				showExchangeRate = true;
				const exchangeRate = AccountingHelper.toFixed(AccountingHelper.getExchangeRate(source, target), 4);

				// TODO: perhaps not store this on the line item so we don't have to do all this
				const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));
				if (selectedLineItem.amount)
				{
					selectedLineItem.targetAmount = AccountingHelper.toFixed(AccountingHelper.convertAmount(selectedLineItem.amount, exchangeRate), 2);
				}
				selectedLineItem.exchangeRate = exchangeRate;
				stateUpdate.selectedLineItem = selectedLineItem;

				stateUpdate.currentExchangeRate = exchangeRate;
			}
		}

		stateUpdate.showExchangeRate = showExchangeRate;

		this.setState(stateUpdate);
	}

	handleNewTagCreate(newOption)
	{
		this.setState({ options: this.state.options.concat(newOption) });
	}

	handleTagsChange(value)
	{
		this.setState({ multiValue: value });
	}

	handleSaveTags()
	{
		this.handleLineItemSave(/*includeTransferId*/ false, /*includeTags*/ true);
		// TODO: implement me
	}

	handleCancelTags()
	{
		//optionsExpanded: false
		this.setState({ multiValue: [] });
	}

	handleFocus()
	{
		clearTimeout(this.blurFocusTimeout);
	}

	handleFieldBlur()
	{
		clearTimeout(this.blurFocusTimeout);
		const $activeRow = $("tr.active");
		this.blurFocusTimeout = setTimeout(() =>
		{
			if (!$activeRow.has(":focus").length)
			{
				this.handleLineItemSave();
			}
		}, 200);
	}

	handleKeyDown(trigger, index, event)
	{
		const selectedLineItem = this.state.selectedLineItem;
		const lineItems = this.state.lineItems;
		const lastRow = index === lineItems.length - 1;
		const lineItemIsNew = selectedLineItem.isNew;

		if(event.key === "Escape")
		{
			this.setState({
				selectedLineItem: null,
				unsavedChanges: false,
				isNew: false,
				optionsExpanded: false,
				showExchangeRate: false,
				transferAccountId: null,
				multiValue: []
			});
		}
		else if(event.key === "Enter" && event.currentTarget.tagName !== "BUTTON")
		{
			event.preventDefault();
			if (event && _.isFunction(event.persist))
			{
				event.persist();
			}
			this.handleLineItemSave().then(() =>
			{
				if(lineItemIsNew)
				{
					this.handleLineItemNew(event);
				}
			});
		}
		else if(event.key === "Tab" && trigger === "deleteButton" && !event.shiftKey)
		{
			// If the options are expanded then tab will jump into it
			if (!this.state.optionsExpanded)
			{
				event.preventDefault();
				if (event && _.isFunction(event.persist))
				{
					event.persist();
				}
				this.handleLineItemSave().then(() =>
				{
					if(lineItemIsNew || lastRow)
					{
						this.handleLineItemNew(event);
					}
					else if(lineItems.length > index)
					{
						this.selectLineItem(lineItems[index + 1].id, event);
					}
				});
			}
		}
		else if(event.key === "Tab" && trigger === "date" && event.shiftKey)
		{
			event.preventDefault();
			if (event && _.isFunction(event.persist))
			{
				event.persist();
			}
			this.handleLineItemSave().then(() =>
			{
				if (index || lineItemIsNew)
				{
					let selectIndex = (lineItemIsNew ? lineItems.length : index) - 1;
					this.selectLineItem(lineItems[selectIndex].id, event);
				}
			});
		}
	}

	handleSplitTransactionEdit(transactionId)
	{
		const isNew = this.state.isNew;
		const selectedLineItem = this.state.selectedLineItem;

		clearTimeout(this.blurFocusTimeout);
		this.setState({
			newSplitDetails: isNew ? selectedLineItem : null,
			showEditModal: true,
			editTransactionId: transactionId,
			selectedLineItem: null,
			unsavedChanges: false,
			optionsExpanded: false,
			showExchangeRate: false,
			transferAccountId: null,
			multiValue: []
		});
	}

	handleEditModalClose()
	{
		this.setState({
			isNew: false,
			newSplitDetails: null,
			showEditModal: false,
			editTransactionId: null
		});
	}

	handleLineItemSave(includeTransferId, includeTags)
	{
		return new Promise((resolve, reject) => {
			// TODO: BA-161 validation
			const unsavedChanges = this.state.unsavedChanges;
			const selectedLineItem = this.state.selectedLineItem;
			const account = this.state.selectedAccount;

			if (selectedLineItem.isNew && unsavedChanges)
			{
				// TODO: BA-161 should we validate that amount exists? what if they say 0? we could do selectedLineItem.hasOwnProperty("amount")
				if (!selectedLineItem.date || !selectedLineItem.description || !selectedLineItem.categoryId || !selectedLineItem.amount)
				{
					console.error("LineItem is missing a field");
					// Missing something...
					reject("LineItem is missing a field");
					return;
				}

				delete selectedLineItem.isNew;
				delete selectedLineItem.id;
			}

			if (includeTransferId)
			{
				selectedLineItem.transferAccountId = this.state.transferAccountId;
			}
			if (includeTags)
			{
				selectedLineItem.tags = this.state.multiValue.map(tag => tag.text);
			}

			selectedLineItem.amount = Math.abs(selectedLineItem.amount);
			if ((selectedLineItem.isExpense && !selectedLineItem.isCreditRefund) || (!selectedLineItem.isExpense && selectedLineItem.isCreditRefund))
			{
				selectedLineItem.amount *= -1;
			}

			this.setState({
				selectedLineItem: null,
				unsavedChanges: false,
				isNew: false,
				optionsExpanded: false,
				showExchangeRate: false,
				transferAccountId: null,
				multiValue: []
			}, () =>
			{
				if (unsavedChanges || includeTransferId || includeTags)
				{
					const lineItemModel = {
						id: selectedLineItem.id,
						date: selectedLineItem.date,
						accountId: account.id,
						amount: selectedLineItem.amount,
						description: selectedLineItem.description,
						categoryId: selectedLineItem.categoryId,
						transactionId: selectedLineItem.transactionId,
						transferAccountId: selectedLineItem.transferAccountId,
						tags: selectedLineItem.tags,
						exchangeRate: selectedLineItem.exchangeRate,
						targetAmount: selectedLineItem.targetAmount
					};

					// TODO: ideally would like to turn this into async but it's complicated because we are waiting for the call here to resolve/reject the promise
					// This is already inside the setState callback
					AccountActions
						.saveLineItem(account, lineItemModel)
						.then(data => resolve(data))
						.catch(message => reject(message));
				}
				else
				{
					resolve();
				}
			});
		});
	}

	handleLineItemDelete()
	{
		const selectedLineItem = this.state.selectedLineItem;

		this.setState({
			selectedLineItem: null,
			unsavedChanges: false,
			isNew: false,
			optionsExpanded: false,
			showExchangeRate: false,
			transferAccountId: null,
			multiValue: []
		}, async () =>
		{
			await AccountActions.deleteLineItem(selectedLineItem);
		});
	}

	handleLineItemNew(event)
	{
		const date = this.state.lastUsedDate || DateHelper.getCurrentDate().toISOString();
		const selectedLineItem = { date, isNew: true };

		this.setState({
			selectedLineItem,
			isNew: true,
			optionsExpanded: false,
			showExchangeRate: false,
			transferAccountId: null,
			multiValue: []
		}, () => {
			if (event)
			{
				// Going down, focus on first item
				$("tr.active .date input").focus();
			}
		});
	}

	handleLineItemNewMobile()
	{
		this.setState({
			showMobileEdit: true,
			isNew: true
		});
	}

	handleLineItemMobile(transactionId)
	{
		this.setState({
			showMobileEdit: true,
			isNew: false,
			editTransactionId: transactionId
		});
	}

	async handleSelectPage(selectedPage)
	{
		const selectedAccount = this.state.selectedAccount;

		if (!selectedAccount || !selectedAccount.id)
		{
			console.error("Attempting to page without a valid account.");
			return;
		}

		await AccountActions.getLineItems(selectedAccount.id, selectedPage, this.state.sort, this.state.search);
	}

	handleSort(sortProperty, event)
	{
		const selectedAccount = this.state.selectedAccount;

		if (!selectedAccount || !selectedAccount.id)
		{
			console.error("Attempting to sort without a valid account.");
			return;
		}

		let sort = this.state.sort;

		if (!event.ctrlKey)
		{
			if (sort.length === 1 && (sort[0] === sortProperty || sort[0] === "-"+sortProperty))
			{
				if (sort[0] === sortProperty)
				{
					sort = ["-"+sortProperty];
				}
				else
				{
					sort = [sortProperty];
				}
			}
			else
			{
				sort = [sortProperty];
			}
		}
		else
		{
			if (sort.indexOf(sortProperty) !== -1)
			{
				sort[sort.indexOf(sortProperty)] = "-"+sortProperty;
			}
			else if (sort.indexOf("-"+sortProperty) !== -1)
			{
				sort[sort.indexOf("-"+sortProperty)] = sortProperty;
			}
			else
			{
				sort.push(sortProperty);
			}
		}

		this.setState({sort}, async () => {
			await AccountActions.getLineItems(selectedAccount.id, this.state.selectedPage, sort, this.state.search);
		});
	}

	handleOptionsToggle(show, callback)
	{
		const stateToSet = { optionsExpanded: show };
		if (show)
		{
			clearTimeout(this.blurFocusTimeout);

			if (this.state.transferAccountId)
			{
				const selectedTransferAccount = this.state.accounts.find(a => a.id === this.state.transferAccountId);
				let source = this.state.selectedAccount.currencyId ? this.state.selectedAccount.currencyId : null;
				let target = selectedTransferAccount && selectedTransferAccount.currencyId ? selectedTransferAccount.currencyId : null;
				let showExchangeRate = false;

				if ((source || target) && source != target)
				{
					showExchangeRate = true;
					const exchangeRate = AccountingHelper.toFixed(AccountingHelper.getExchangeRate(source, target), 4);

					const selectedLineItem = JSON.parse(JSON.stringify(this.state.selectedLineItem));

					if (selectedLineItem.amount && selectedLineItem.targetAmount)
					{
						selectedLineItem.exchangeRate = selectedLineItem.targetAmount / selectedLineItem.amount;
					}
					else if (selectedLineItem.amount)
					{
						selectedLineItem.targetAmount = AccountingHelper.toFixed(AccountingHelper.convertAmount(selectedLineItem.amount, exchangeRate), 2);
						selectedLineItem.exchangeRate = exchangeRate;
					}
					else
					{
						selectedLineItem.exchangeRate = exchangeRate;
					}

					stateToSet.selectedLineItem = selectedLineItem;
					stateToSet.currentExchangeRate = exchangeRate;
				}

				stateToSet.showExchangeRate = showExchangeRate;
			}
		}
		if (!show)
		{
			stateToSet.showExchangeRate = false;
			stateToSet.multiValue = [];
			stateToSet.transferAccountId = null;
			if (!callback)
			{
				callback = () => $("tr.active .descriptionComplete input").focus();
			}
			// this.setState({
			// 	//optionsExpanded: false,
			// 	transferAccountId: null
			// }, () => $("tr.active .descriptionComplete input").focus());
		}
		this.setState(stateToSet, callback);
	}

	handleWindowSizeChange()
	{
		this.setState({ width: window.innerWidth, height: window.innerHeight - 60 });
	}

	navigateToAccount(kebabName)
	{
		this.setState({
			isNew: false,
			selectedLineItem: null,
			accountCollapsed: true
		}, async () => {
			this.props.history.push(`/transactions/${kebabName}`);
			await AccountActions.selectAccount(this.state.accounts.map(a => a.kebabName).indexOf(kebabName), this.state.sort, this.state.search);
		});
	}

	// Method to setState based upon Store changes
	_onChange()
	{
		this.setState(Transactions.getStoreState());
	}

	componentDidUpdate()
	{
		let accountName = this.props.match && this.props.match.params && this.props.match.params.accountName;
		if (!accountName && AccountStore.getSelected() !== null)
		{
			// Clear selection
			AccountActions.selectAccount(-1);
		}

		if (this.activeRow)
		{
			// TODO: put bg on #transactionoptions (and border radius), remove from #transactionOptions .thing
			const $activeRow = $(ReactDOM.findDOMNode(this.activeRow));
			const $transactionOptions = $("#transactionOptions");
			if ($activeRow.length > 0 && $transactionOptions.length > 0)
			{
				$transactionOptions.hide();
				const top = $activeRow.position().top + $activeRow.height();
				const style = {position: "absolute", display: "block", top};
				if ($transactionOptions.is(".collapsed"))
				{
					style.left = ($activeRow.width()/2) - ($transactionOptions.width()/2);
				}

				$transactionOptions.css(style);
				$transactionOptions.show();
			}
		}
	}

	// Add change listeners to stores
	componentDidMount()
	{
		const originalSearch = this.handleSearch;
		this.handleSearch = _.debounce(originalSearch, 1000);
		this.immediateSearch = _.debounce(() => {
			this.handleSearch.cancel();
			originalSearch(this.state.search);
		}, 1000, { leading: true, trailing: false });
		window.addEventListener("resize", this.handleWindowSizeChange);

		Mousetrap.bind("n", "New Transaction", (event) => { if (this.state.selectedAccount) { this.handleLineItemNew(event); } }, "keyup");
		Mousetrap.bind("mod+s", "Save", () => { this.handleLineItemSave(); return false; });
		Mousetrap.bind("mod+o", "Open Advanced Options", () =>
		{
			if (this.state.selectedLineItem)
			{
				let wasExpanded = this.state.optionsExpanded;
				this.handleOptionsToggle(!wasExpanded, () => {
					if (wasExpanded)
					{
						// Need to see if our row has focus in it
						const $activeRow = $("tr.active");
						if (!$activeRow.has(":focus").length)
						{
							$activeRow.find(".descriptionComplete input").focus();
						}
					}
				});

				// Most browsers use mod+o for open file so we need to override that
				// We are making the assumption that people don't really use that hotkey
				// In case they do, we are only overriding if a row is open
				return false;
			}
		});
		Mousetrap.bind("mod+r", "Select an Account for transfer", () =>
		{
			if (this.state.selectedLineItem)
			{
				this.handleOptionsToggle(true, () => {
					const $transactionOptions = $("#transactionOptions");
					$transactionOptions.find(".accountTransferSelect").focus();
				});

				// In case the people use this key combination, we are only overriding if a row is open
				return false;
			}
		});
		Mousetrap.bind("mod+g", "Add a tag to a transaction", () =>
		{
			if (this.state.selectedLineItem) {
				this.handleOptionsToggle(true, () => {
					const $transactionOptions = $("#transactionOptions");
					$transactionOptions.find(".transactionTagsSelect input").focus();
				});

				// In case the people use this key combination, we are only overriding if a row is open
				return false;
			}
		});

		AccountStore.addChangeListener(this._onChange);
		CategoryStore.addChangeListener(this._onChange);
		TagStore.addChangeListener(this._onChange);

		window.addEventListener("scroll", this.handleScroll);

		this.makeRemoteRequest();
	}

	async makeRemoteRequest()
	{
		const selectedAccount = this.props.match && this.props.match.params && this.props.match.params.accountName;
		await AccountActions.getAccounts(selectedAccount);
		await TagActions.initialize();
		await CategoryActions.initialize();
	}

	// Remove change listeners from stores
	componentWillUnmount()
	{
		window.removeEventListener("scroll", this.handleScroll);
		window.removeEventListener("resize", this.handleWindowSizeChange);
		AccountStore.removeChangeListener(this._onChange);
		CategoryStore.removeChangeListener(this._onChange);
		TagStore.removeChangeListener(this._onChange);
		Mousetrap.unbind("n", "keyup");
		Mousetrap.unbind("mod+s");
		Mousetrap.unbind("mod+o");
		Mousetrap.unbind("mod+r");
		Mousetrap.unbind("mod+g");
	}

	renderLineItem(lineItem, options)
	{
		const { selectedAccount, categories, numberDecimals } = this.state;
		const { selectedLineItem, isNew, index } = options;

		if (isNew && !lineItem)
		{
			return null;
		}

		if (selectedLineItem && (isNew || selectedLineItem.id === lineItem.id))
		{
			// Note: key falls back to -1 for new items
			const disableSplit = !isNew && this.state.unsavedChanges;
			return (
				<tr key={lineItem.id || -1} className="active" ref={(row) => this.activeRow = row}>
					<td
						onKeyDown={this.handleKeyDown.bind(this, "date", index)}
						className="date"
					>
						<DatePicker
							className="input-sm mousetrap-mod"
							value={DateHelper.toISOString(selectedLineItem.date)}
							onChange={this.handleLineItemDateChange}
							onFocus={this.handleFocus}
							onBlur={this.handleFieldBlur}
							showClearButton={false}
							style={{width: "91%"}}
						/>
					</td>
					<td>
						<DescriptionComplete
							className="mousetrap-mod"
							value={selectedLineItem.description || ""}
							onSelect={this.handleLineItemDescriptionSelect}
							onChange={this.handleLineItemDescriptionChange}
							onFocus={this.handleFocus}
							onBlur={this.handleFieldBlur}
							onKeyDown={this.handleKeyDown.bind(this, "description", index)}
						/>
					</td>
					<td>
						<CategorySelect
							className="mousetrap-mod"
							onSelect={this.handleLineItemCategoryChange}
							onFocus={this.handleFocus}
							onBlur={this.handleFieldBlur}
							value={selectedLineItem.categoryId}
							onKeyDown={this.handleKeyDown.bind(this, "category", index)}
							options={categories}
						/>
					</td>
					<td>
						<InputAmount
							className="mousetrap-mod"
							value={Math.abs(selectedLineItem.amount)}
							onChange={this.handleLineItemAmountChange}
							onFocus={this.handleFocus}
							onBlur={this.handleFieldBlur}
							onKeyDown={this.handleKeyDown.bind(this, "amount", index)}
							numberDecimals={numberDecimals}
						/>
					</td>
					<td>
						<div className="checkbox">
							<label>
								<input
									type="checkbox"
									className="mousetrap-mod"
									defaultChecked={selectedLineItem.isCreditRefund}
									onBlur={this.handleFieldBlur}
									onChange={this.handleLineItemIsCreditRefundChange}
									onKeyDown={this.handleKeyDown.bind(this, "isCreditRefund", index)}
								/>
								{selectedLineItem.isExpense ? "Refund" : "Credit"}
							</label>
						</div>
					</td>
					<td>
						<button
							className={classNames("btn-sm btn-default", { disabled: disableSplit })}
							onClick={this.handleSplitTransactionEdit.bind(this, selectedLineItem.transactionId)}
							onFocus={this.handleFocus}
							onBlur={this.handleFieldBlur}
							disabled={disableSplit}
						>
							<Glyphicon glyph="resize-full"/>
						</button>
						<button
							className="glyphicon glyphicon-trash btn-sm btn-danger"
							onClick={this.handleLineItemDelete}
							onFocus={this.handleFocus}
							onBlur={this.handleFieldBlur}
							onKeyDown={this.handleKeyDown.bind(this, "deleteButton", index)}
						/>
					</td>
				</tr>
			);
		}

		let amount = lineItem.amount;
		const date = DateHelper.getDate(lineItem.date);
		const dateString = date
			? `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
			: "";
		let categoryName = "";
		const category = categories.find(cat => cat.id === lineItem.categoryId);
		if (category)
		{
			categoryName = category.name;
		}

		// Note: the key falls back to -2 in case the item is currently saving and we are optimistically rendering
		// -1 is used for a new item
		return (
			<tr key={lineItem.id || -2} onClick={this.selectLineItem.bind(this, lineItem.id)}>
				<td>{dateString}</td>
				<td>{lineItem.description}</td>
				<td>{categoryName}</td>
				<td className={classNames("text-right", { "text-success": amount > 0 })}>{AccountingHelper.formatMoney(amount, selectedAccount.currencyId, numberDecimals)}</td>
				<td className="text-center">{lineItem.splitTransaction ? <Glyphicon glyph="resize-full" /> : ""}</td>
				<td className="text-center">{this.renderLineItemTags(lineItem.tags, lineItem.id)}</td>
			</tr>
		);
	}

	renderLineItemTags(tags, lineItemId)
	{
		if (!tags || tags.length === 0)
		{
			return "";
		}

		const listTags = tags.length > 1;
		const tagsTooltipItems = tags.map((tag) =>
		{
			return listTags ? <div key={`tag_${tag}`}>{tag}</div> : tag;
		});

		const tagToolTip = (
			<Tooltip id={`lineItem${lineItemId}_tags`}>
				{tagsTooltipItems}
			</Tooltip>
		);

		return (
			<OverlayTrigger
				placement="bottom"
				overlay={tagToolTip}
			>
				<Glyphicon glyph={listTags ? "tags" : "tag"} />
			</OverlayTrigger>
		);
	}

	renderHeader(columnWidth, columnName, sortable)
	{
		const sort = this.state.sort;
		const lowerName = columnName.toLowerCase();
		let glyph = null;
		if (sortable && sort.indexOf(lowerName) !== -1)
		{
			glyph = <span><Glyphicon glyph="chevron-up" /></span>;
		}
		else if (sortable && sort.indexOf("-"+lowerName) !== -1)
		{
			glyph = <span><Glyphicon glyph="chevron-down" /></span>;
		}

		return (
			<th className={`col-md-${columnWidth}`}>
				<span
					className={"unselectable" + (sortable ? " sortable-header" : "")}
					onClick={sortable ? this.handleSort.bind(this, lowerName) : null}
				>
					{columnName}{glyph}
				</span>
			</th>
		);
	}

	renderNonMobileTransactionsTable()
	{
		const { selectedLineItem, lineItems, accounts, isNew } = this.state;

		if (!isNew && lineItems.length === 0)
		{
			return <h3>No transactions for this Account</h3>;
		}

		let selectedAccount = this.state.selectedAccount;
		if (!selectedAccount && isNew)
		{
			selectedAccount = {};
		}

		const selectedAccountId = selectedAccount ? selectedAccount.id : null;

		return (
			<Table>
				<thead>
					<tr>
						{/*Would like to support search but don't currently have a good way to do so*/}
						{this.renderHeader(2, "Date", false)}
						{this.renderHeader(4, "Description")}
						{this.renderHeader(2, "Category")}
						{this.renderHeader(1, "Amount", false)}
						{this.renderHeader(1, "")}
						{this.renderHeader(2, "")}
					</tr>
				</thead>
				<tbody>
					{
						lineItems.map((lineItem, index) =>
						{
							return this.renderLineItem(lineItem,
								{
									selectedAccountId,
									selectedLineItem,
									accounts,
									index
								});
						})
					}
					{
						isNew &&
						this.renderLineItem(selectedLineItem,
							{
								isNew,
								selectedLineItem,
								accounts
							})
					}
				</tbody>
			</Table>
		);
	}

	renderNonMobile()
	{
		const { selectedLineItem, paging, accounts, multiValue, options, tags, showExchangeRate } = this.state;
		const tagOptions = [].concat(tags);
		options.forEach(opt =>
		{
			if (!tagOptions.includes(tag => tag.text === opt.text))
			{
				tagOptions.push(opt);
			}
		});
		const hasManyPages = paging && paging.totalPages > 10;
		const accountsToDisplay = accounts.filter(account => account.type === Enums.accountType.asset);

		return (
			<div className="transactions">
				<Row>
					<Col xs={4}>
						<div className="input-group">
							<FormControl
								type="text"
								value={this.state.search || ""}
								onChange={this.handleSearchStringChange}
								onKeyPress={(e) => { (e.keyCode || e.which) === 13 ? this.immediateSearch() : null; }}
							/>
							<span className="input-group-btn">
								<button className="btn btn-default" type="button" onClick={this.immediateSearch}>
									<Glyphicon glyph="search" />
								</button>
							</span>
						</div>
					</Col>
					<Col xs={4}>
						<button className="btn btn-primary" onClick={this.handleLineItemNew}>New Transaction</button>
					</Col>
				</Row>
				{this.renderNonMobileTransactionsTable()}
				{selectedLineItem && this.state.optionsExpanded &&
					// TODO: create transactionoptions component
					// hidden until shown by componentDidUpdate
					<div id="transactionOptions" className="panel panel-primary expanded" style={{display: "hidden"}}>
						<div className="panel-heading">
							<h3 className="panel-title">Transaction Options</h3>
						</div>
						<div className="panel-body">
							<Row className={classNames({ "offset-row": showExchangeRate })}>
								<Col xs={4}>
									Select an Account for transfer
								</Col>
								<Col xs={5}>
									<FormControl
										componentClass="select"
										bsClass="accountTransferSelect form-control input-sm mousetrap-mod"
										onChange={this.handleTransferAccountSelected}
										onFocus={this.handleFocus}
										value={this.state.transferAccountId || ""}
									>
										<option value="" />
										{accountsToDisplay &&
											accountsToDisplay.map(account => {
												if (account.hideIfEmpty && account.amount === 0) {
													return null;
												}

												return (
													<option key={account.id} value={account.id}>
														{account.name}
													</option>
												);
											})
										}
									</FormControl>
								</Col>
								<Col xs={3}>
									<Button
										bsSize={"sm"}
										bsStyle={"success"}
										onClick={this.handleCreateTransfer}
										onFocus={this.handleFocus}
									>
										Save
									</Button>
									<Button
										bsSize={"sm"}
										onClick={this.handleCancelTransfer}
										onFocus={this.handleFocus}
									>
										Clear
									</Button>
								</Col>
							</Row>
							{showExchangeRate &&
								<Row className="offset-row">
									<Col xs={3} xsOffset={1}>
										Exchange Rate
									</Col>
									<Col xs={5}>
										<InputAmount
											className="mousetrap-mod"
											value={Math.abs(selectedLineItem.exchangeRate)}
											onChange={this.handleExchangeRateChange}
											onFocus={this.handleFocus}
											numberDecimals={4}
										/>
									</Col>
									<Col xs={3}>{`Current rate: ${AccountingHelper.toFixed(this.state.currentExchangeRate, 4)}`}</Col>
								</Row>
							}
							{showExchangeRate &&
								<Row>
									<Col xs={3} xsOffset={1}>
										Target Amount
									</Col>
									<Col xs={5}>
										<InputAmount
											className="mousetrap-mod"
											value={Math.abs(selectedLineItem.targetAmount)}
											onChange={this.handleTargetAmountChange}
											onFocus={this.handleFocus}
										/>
									</Col>
									<Col xs={3}></Col>
								</Row>
							}
							<hr />
							<Row>
								<Col xs={4}>
									Tags
								</Col>
								<Col xs={5}>
									<Creatable
										className="transactionTagsSelect"
										multi={true}
										options={tagOptions}
										onChange={this.handleTagsChange}
										onNewOptionClick={this.handleNewTagCreate}
										value={multiValue}
										valueKey="text"
										labelKey="text"
									/>
								</Col>
								<Col xs={3}>
									<Button
										bsSize={"sm"}
										bsStyle={"success"}
										onClick={this.handleSaveTags}
										onFocus={this.handleFocus}
									>
										Save
									</Button>
									<Button
										bsSize={"sm"}
										onClick={this.handleCancelTags}
										onFocus={this.handleFocus}
									>
										Clear
									</Button>
								</Col>
							</Row>
						</div>
						<Glyphicon
							className="bg-primary"
							glyph="chevron-up"
							onClick={this.handleOptionsToggle.bind(this, false, null)}
						/>
					</div>
				}
				{selectedLineItem && !this.state.optionsExpanded &&
					<div id="transactionOptions" className="collapsed">
						<Glyphicon
							className="bg-primary"
							glyph="chevron-down"
							onClick={this.handleOptionsToggle.bind(this, true, null)}
						/>
					</div>
				}
				{paging && paging.totalPages > 1 &&
					<div id="paging">
						<Pagination
							prev
							next
							items={paging.totalPages}
							activePage={paging.pageIndex}
							onSelect={this.handleSelectPage}
							first={hasManyPages}
							last={hasManyPages}
							ellipsis={hasManyPages}
							boundaryLinks={hasManyPages}
							maxButtons={hasManyPages ? 5 : null}
						/>
					</div>
				}
			</div>
		);
	}

	renderMobile()
	{
		const { selectedAccount, lineItems, paging, categories } = this.state;
		const hasManyPages = paging && paging.totalPages > 10;

		return (
			<div className="transactions">
				<Row>
					<Col xs={12}>
						<div className="input-group">
							<FormControl
								type="text"
								value={this.state.search || ""}
								onChange={this.handleSearchStringChange}
								onKeyPress={(e) => { (e.keyCode || e.which) === 13 ? this.immediateSearch() : null; }}
							/>
							<span className="input-group-btn">
								<button className="btn btn-default" type="button" onClick={this.immediateSearch}>
									<Glyphicon glyph="search" />
								</button>
							</span>
						</div>
					</Col>
				</Row>
				{
					lineItems.map((lineItem) =>
					{
						const date = DateHelper.getDate(lineItem.date);
						const dateString = date
							? `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`
							: "";
						const amount = lineItem.amount;
						let categoryName = "";
						const category = categories.find(cat => cat.id === lineItem.categoryId);
						if (category)
						{
							categoryName = category.name;
						}

						return (
							<Row key={lineItem.id} className="transaction-mobile" role="button" onClick={this.handleLineItemMobile.bind(this, lineItem.transactionId)}>
								<Col xs={3}>
									<div>{dateString}</div>
									<div className={classNames({"text-success": amount > 0})}>{AccountingHelper.formatMoney(amount, selectedAccount.currencyId)}</div>
									<div>{this.renderLineItemTags(lineItem.tags, lineItem.id)}</div>
								</Col>
								<Col xs={9}>
									<p>{lineItem.description}</p>
									<p className="text-muted">{categoryName}</p>
								</Col>
							</Row>
						);
					})
				}
				{paging && paging.totalPages > 1 &&
					<div id="paging">
						<Pagination
							prev
							next
							items={paging.totalPages}
							activePage={paging.pageIndex}
							onSelect={this.handleSelectPage}
							first={hasManyPages}
							last={hasManyPages}
							ellipsis={hasManyPages}
							boundaryLinks={hasManyPages}
							maxButtons={hasManyPages ? 5 : null}
						/>
					</div>
				}
				<div className="new-transaction-mobile">
					<button className="btn btn-primary" type="button" onClick={this.handleLineItemNewMobile}>
						<Glyphicon glyph="plus" />
					</button>
				</div>
			</div>
		);
	}

	render()
	{
		let { selectedAccount, showHoverAccount } = this.state;
		const { accounts, isNew, numberDecimals, width } = this.state;
		const accountsToDisplay = accounts.filter(account => account.type === Enums.accountType.asset);
		if (!selectedAccount && isNew)
		{
			selectedAccount = {};
		}

		const isMobile = width < 768;
		const selectedAccountId = selectedAccount ? selectedAccount.id : null;
		const selectedAccountName = selectedAccount ? selectedAccount.kebabName : null;
		showHoverAccount = showHoverAccount && !isMobile && width >= 1100 && !!selectedAccount;

		if (this.state.showMobileEdit) {
			return (
				<TransactionMobileEdit
					onClose={() => { this.setState({ showMobileEdit: false, isNew: false }); }}
					transactionId={this.state.editTransactionId}
					accountId={selectedAccountId}
					currencyId={selectedAccount ? selectedAccount.currencyId : null}
					numberDecimals={numberDecimals}
					isNew={isNew}
				/>
			);
		}

		return (
			<Row>
				{this.state.showEditModal &&
					<SplitTransactionEdit
						transactionId={this.state.editTransactionId}
						accountId={selectedAccountId}
						onClose={this.handleEditModalClose}
						currencyId={selectedAccount ? selectedAccount.currencyId : null}
						numberDecimals={numberDecimals}
						isNew={isNew}
						newSplitDetails={this.state.newSplitDetails}
					/>
				}
				{showHoverAccount && (
					<div id="account-info-floating-label" className="bg-primary navbar">
						<div>Selected Account:<span className="label label-info">{selectedAccount.name}</span></div>
						<div>Current Amount:<span className="label label-info">{AccountingHelper.formatMoney(selectedAccount.amount, selectedAccount.currencyId)}</span></div>
					</div>
				)}
				<Col xs={12} md={3} id="accountsContainer">
					<h1 className="page-header hidden-xs">Accounts</h1>
					{(isMobile && this.state.accountCollapsed) ?
						<Nav bsStyle="pills" stacked activeKey={selectedAccountName} onSelect={() => { this.setState({ accountCollapsed: false }); }}>
							{selectedAccount ?
								<LinkContainer to={`/transactions/${selectedAccount.kebabName}`}>
									<NavItem eventKey={selectedAccount.kebabName} href={`/transactions/${selectedAccount.kebabName}`}>
										{selectedAccount.name}
										<span className="pull-right">
											{selectedAccount.hideIfEmpty && <span className="label label-warning">inactive</span>}
											<span className="label label-info">{AccountingHelper.formatMoney(selectedAccount.amount, selectedAccount.currencyId)}</span>
											<Glyphicon glyph="chevron-down" id="transactionAccountDropdown" />
										</span>
									</NavItem>
								</LinkContainer>
								:
								<NavItem>
									Select account
									<Glyphicon glyph="chevron-down" className="pull-right" />
								</NavItem>
							}
						</Nav>
						:
						<Nav bsStyle="pills" stacked activeKey={selectedAccountName} onSelect={this.navigateToAccount}>
							{
								accountsToDisplay &&
								accountsToDisplay.map(account => {
									if (account.hideIfEmpty && account.amount === 0) {
										return null;
									}

									return (
										<LinkContainer to={`/transactions/${account.kebabName}`} key={account.id}>
											<NavItem
												eventKey={account.kebabName}
												href={`/transactions/${account.kebabName}`}
												disabled={!isMobile && account.id === selectedAccountId}
											>
												{account.name}
												<span className="label label-info pull-right">{AccountingHelper.formatMoney(account.amount, account.currencyId)}</span>
												{account.hideIfEmpty && <span className="label label-warning pull-right">inactive</span>}
											</NavItem>
										</LinkContainer>
									);
								})
							}
						</Nav>
					}
				</Col>
				<Col xs={12} md={9} style={{ marginBottom: this.state.height + "px" }}>
					{selectedAccount && !isMobile &&
						this.renderNonMobile()
					}
					{selectedAccount && isMobile &&
						this.renderMobile()
					}
					{!selectedAccount &&
						<div>No account selected</div>
					}
				</Col>
			</Row>
		);
	}
}

Transactions.propTypes = {
	history: PropTypes.object,
	match: PropTypes.object
};



// WEBPACK FOOTER //
// ./Components/components/Transactions.jsx